import {
    setLocationsParamsIsAvailable,
    setLocationsParamsIsFree,
} from '../../../../store/locations/locations-list.slice';

export enum EFilters {
    'FREE' = 'free',
    'PAID' = 'paid',
    'AVAILABLE' = 'available',
    'CANADIAN' = 'canadian',
}

export const filtersValues = [
    {
        id: EFilters.FREE,
        label: 'filters.free',
        params: 'isFree',
        reducer: setLocationsParamsIsFree,
        isQuickFilter: true,
        activeValue: true
    },
    // {
    //     id: EFilters.AVAILABLE,
    //     label: 'filters.available',
    //     params: 'connectorStatus',
    //     reducer: setLocationsParamsIsAvailable,
    //     isQuickFilter: true,
    //     activeValue: EFilters.AVAILABLE
    // },
    {
        id: EFilters.AVAILABLE,
        label: 'filters.available',
        params: 'isConnectorAvailable',
        reducer: setLocationsParamsIsAvailable,
        isQuickFilter: true,
        activeValue: EFilters.AVAILABLE
    },
];
